// 翻页时钟功能实现

var Flipper = /** @class */ (function() {
    function Flipper(node, currentTime, nextTime) {
        this.isFlipping = false;
        this.duration = 600; // 恢复为600ms，匹配CSS动画时长
        this.flipNode = node;
        this.frontNode = node.querySelector(".front");
        this.backNode = node.querySelector(".back");
        this.setFrontTime(currentTime);
        this.setBackTime(nextTime);
    }
    Flipper.prototype.setFrontTime = function(time) {
        this.frontNode.dataset.number = time;
    };
    Flipper.prototype.setBackTime = function(time) {
        this.backNode.dataset.number = time;
    };
    Flipper.prototype.flipDown = function(currentTime, nextTime) {
        var _this = this;
        if(this.isFlipping) {
            return false;
        }
        this.isFlipping = true;
        this.setFrontTime(currentTime);
        this.setBackTime(nextTime);
        
        // 定义动画结束事件处理函数
        var handleAnimationEnd = function() {
            _this.flipNode.classList.remove("running");
            _this.isFlipping = false;
            _this.setFrontTime(nextTime);
            // 移除事件监听器，避免内存泄漏
            _this.flipNode.removeEventListener('animationend', handleAnimationEnd);
        };
        
        // 添加动画结束事件监听
        this.flipNode.addEventListener('animationend', handleAnimationEnd);
        
        // 启动动画
        this.flipNode.classList.add("running");
    };
    return Flipper;
}());

// 全局设置变量 - 从localStorage读取初始值
var use24HourFormat = localStorage.getItem('flip-clock-24hour') !== 'false'; // 默认24小时制
var showSeconds = localStorage.getItem('flip-clock-seconds') !== 'false';    // 默认显示秒数

// 时间格式化函数
var getTimeFromDate = function(date) {
    let hours = date.getHours();
    let minutes = date.getMinutes();
    let seconds = date.getSeconds();
    
    // 处理12小时制
    if (!use24HourFormat) {
        hours = hours % 12;
        if (hours === 0) hours = 12; // 12小时制中午夜12点显示为12
    }
    
    // 转为两位数字符串
    hours = hours.toString().padStart(2, '0');
    minutes = minutes.toString().padStart(2, '0');
    seconds = seconds.toString().padStart(2, '0');
    
    // 返回结果字符串，用于更新翻页器
    if (showSeconds) {
        return hours + minutes + seconds;
    } else {
        return hours + minutes;
    }
};

// 这些变量将在DOM准备好后初始化
var flippers = [];

// 重置时钟显示，强制刷新所有数字
function resetClock() {
    // 获取当前时间
    var now = new Date();
    var timeStr = getTimeFromDate(now);
    
    // 重新创建所有翻页器
    var flips = document.querySelectorAll(".flip");
    
    // 立即控制秒数翻页器和分钟后面冒号的显示/隐藏，避免闪烁
    var secondsFlips = document.querySelectorAll(".clock .flip:nth-child(7), .clock .flip:nth-child(8)");
    var secondsDivider = document.querySelector(".clock .divider:nth-child(6)");
    
    secondsFlips.forEach(function(element) {
        element.style.display = showSeconds ? "flex" : "none";
    });
    
    if (secondsDivider) {
        secondsDivider.style.display = showSeconds ? "block" : "none";
    }
    
    // 更新所有翻页器的当前值
    for(var i=0; i < flips.length; i++) {
        var frontDigit = flips[i].querySelector(".front");
        var backDigit = flips[i].querySelector(".back");
        
        if(frontDigit && backDigit) {
            // 设置前后面数字为相同的当前值
            frontDigit.setAttribute("data-number", timeStr[i] || "0");
            backDigit.setAttribute("data-number", timeStr[i] || "0");
        }
    }
    
    // 强制执行一次翻转动画
    setTimeout(function() {
        updateClock(now);
    }, 50);
}

// 更新时间的函数
function updateClock(now) {
    var nowTimeStr = getTimeFromDate(new Date(now.getTime() - 1000));
    var nextTimeStr = getTimeFromDate(now);
    
    // 更新翻页
    var maxLength = showSeconds ? 6 : 4;  // 显示秒数时6位(HHMMSS)，不显示时4位(HHMM)
    for(var i=0; i < Math.min(flippers.length, maxLength); i++) {
        if(nowTimeStr[i] === nextTimeStr[i]) {
            continue;
        }
        flippers[i].flipDown(nowTimeStr[i], nextTimeStr[i]);
    }
    
    // 控制秒数翻页器和分钟后面冒号的显示/隐藏
    // 选择第7和第8个子元素（秒数的十位和个位）和第6个子元素（秒数前的冒号分隔符）
    var secondsFlips = document.querySelectorAll(".clock .flip:nth-child(7), .clock .flip:nth-child(8)");
    var secondsDivider = document.querySelector(".clock .divider:nth-child(6)");
    
    secondsFlips.forEach(function(element) {
        element.style.display = showSeconds ? "flex" : "none";
    });
    
    if (secondsDivider) {
        secondsDivider.style.display = showSeconds ? "block" : "none";
    }
}

// 时钟管理器
var clockTimer = null;

// 启动时钟
function startClock() {
    // 先停止已有的定时器
    stopClock();
    
    // 立即更新一次时间
    updateClock(new Date());
    
    // 设置新的定时器
    clockTimer = setInterval(function() {
        updateClock(new Date());
    }, 1000);
}

// 停止时钟
function stopClock() {
    if (clockTimer) {
        clearInterval(clockTimer);
        clockTimer = null;
    }
}

// 初始化时钟（在DOM准备好后调用）
function initializeClock() {
    var flips = document.querySelectorAll(".flip");
    var now = new Date();
    var nowTimeStr = getTimeFromDate(new Date(now.getTime() - 1000));
    var nextTimeStr = getTimeFromDate(now);
    flippers = Array.from(flips).map(function(flip, i) {return new Flipper(flip, nowTimeStr[i], nextTimeStr[i]);});
    
    // 启动时钟
    startClock();
}

// FlipClock类，提供外部接口
class FlipClock {
    constructor() {
        // 从localStorage读取设置，使用正确的默认值
        this.use24HourFormat = localStorage.getItem('flip-clock-24hour') !== 'false';
        this.showSeconds = localStorage.getItem('flip-clock-seconds') !== 'false';
        this.showDateYear = localStorage.getItem('flip-clock-date') === 'true';
        
        this.clockContainer = document.getElementById('clock-container');
        this.dateYearDisplay = document.getElementById('date-year-display');
        this.dateYearText = document.getElementById('date-year-text');
        
        // 同步全局变量
        use24HourFormat = this.use24HourFormat;
        showSeconds = this.showSeconds;
        
        // 立即处理秒数卡片显示状态，避免页面加载时闪现
        this.initSecondsDisplay();
        
        this.bindTemplateEvents();
        this.initDateYear();
    }

    // 初始化秒数显示状态
    initSecondsDisplay() {
        // 立即控制秒数翻页器和分隔符的显示/隐藏
        const secondsFlips = document.querySelectorAll(".clock .flip:nth-child(7), .clock .flip:nth-child(8)");
        const secondsDivider = document.querySelector(".clock .divider:nth-child(6)");
        
        secondsFlips.forEach(function(element) {
            element.style.display = showSeconds ? "flex" : "none";
        });
        
        if (secondsDivider) {
            secondsDivider.style.display = showSeconds ? "block" : "none";
        }
    }

    // 绑定模版相关事件
    bindTemplateEvents() {
        // 监听模版变更事件
        document.addEventListener('templateChange', (e) => {
            this.onTemplateChange(e.detail.template);
        });
    }

    // 处理模版变更
    onTemplateChange(templateName) {
        // FlipClock不需要特殊处理，CSS会自动应用新的变量值
        // 这里可以添加一些特殊的逻辑，比如重新渲染或动画效果
        
        // 如果需要，可以触发重新渲染
        // resetClock();
    }
    
    // 初始化日期年份显示
    initDateYear() {
        // 根据设置控制显示状态
        if (this.dateYearDisplay) {
            this.dateYearDisplay.style.display = this.showDateYear ? 'block' : 'none';
        }
        
        this.updateDateYear();
        // 每秒更新日期年份（虽然不常变，但确保准确性）
        setInterval(() => {
            this.updateDateYear();
        }, 1000);
    }
    
    // 更新日期年份显示
    updateDateYear() {
        if (!this.dateYearText) return;
        
        const now = new Date();
        const options = { 
            weekday: 'long', 
            year: 'numeric', 
            month: 'long', 
            day: 'numeric' 
        };
        
        // 获取当前页面的语言设置
        const locale = this.getPageLocale();
        const formattedDate = now.toLocaleDateString(locale, options);
        
        this.dateYearText.textContent = formattedDate;
    }
    
    // 获取页面locale（与digital-clock保持一致）
    getPageLocale() {
        // 从HTML lang属性获取语言代码
        const langCode = document.documentElement.lang || 'en';
        
        // 语言代码到locale的映射
        const localeMap = {
            'en': 'en-US',
            'es': 'es-ES',
            'fr': 'fr-FR',
            'pt': 'pt-PT'
        };
        
        return localeMap[langCode] || 'en-US';
    }
    
    // 切换日期年份显示
    toggleDateYear() {
        this.showDateYear = !this.showDateYear;
        localStorage.setItem('flip-clock-date', this.showDateYear.toString());
        
        if (this.dateYearDisplay) {
            this.dateYearDisplay.style.display = this.showDateYear ? 'block' : 'none';
        }
    }
    
    // 切换24小时制
    toggle24Hour() {
        this.use24HourFormat = !this.use24HourFormat;
        localStorage.setItem('flip-clock-24hour', this.use24HourFormat.toString());
        use24HourFormat = this.use24HourFormat;
        resetClock();
    }
    
    // 切换秒数显示
    toggleSeconds() {
        this.showSeconds = !this.showSeconds;
        localStorage.setItem('flip-clock-seconds', this.showSeconds.toString());
        showSeconds = this.showSeconds;
        
        // 立即应用显示/隐藏状态
        // 选择第7和第8个子元素（秒数的十位和个位）和第6个子元素（秒数前的冒号分隔符）
        const secondsFlips = document.querySelectorAll(".clock .flip:nth-child(7), .clock .flip:nth-child(8)");
        const secondsDivider = document.querySelector(".clock .divider:nth-child(6)");
        
        secondsFlips.forEach(function(element) {
            element.style.display = showSeconds ? "flex" : "none";
        });
        
        if (secondsDivider) {
            secondsDivider.style.display = showSeconds ? "block" : "none";
        }
        
        // 重新初始化时钟以确保状态同步
        resetClock();
    }
    
    // 获取当前设置
    getSettings() {
        return {
            is24Hour: this.use24HourFormat,
            showSeconds: this.showSeconds,
            showDateYear: this.showDateYear
        };
    }
    
    // 进入全屏
    enterFullscreen() {
        if (this.clockContainer && !document.fullscreenElement) {
            this.clockContainer.requestFullscreen().then(() => {
                this.clockContainer.classList.add('fullscreen-mode');
                // 集成FullscreenManager的Wake Lock功能，保持屏幕常亮
                if (window.fullscreenManager) {
                    window.fullscreenManager.requestWakeLock();
                }
            }).catch(err => {
                console.error(`全屏模式启用失败: ${err.message}`);
            });
        }
    }
    
    // 退出全屏
    exitFullscreen() {
        if (document.fullscreenElement && document.exitFullscreen) {
            document.exitFullscreen().then(() => {
                if (this.clockContainer) {
                    this.clockContainer.classList.remove('fullscreen-mode');
                }
                // 退出全屏时，如果用户没有主动开启防息屏，则释放Wake Lock
                if (window.fullscreenManager && !window.fullscreenManager.isStayOnActive) {
                    window.fullscreenManager.releaseWakeLock();
                }
            }).catch(err => {
                if (this.clockContainer) {
                    this.clockContainer.classList.remove('fullscreen-mode');
                }
                // 即使出错也要尝试释放Wake Lock
                if (window.fullscreenManager && !window.fullscreenManager.isStayOnActive) {
                    window.fullscreenManager.releaseWakeLock();
                }
            });
        }
    }
    
    // 切换全屏状态
    toggleFullscreen() {
        if (!document.fullscreenElement) {
            this.enterFullscreen();
        } else {
            this.exitFullscreen();
        }
    }
}

let isFlipClockInitialized = false;

function initializeFlipClock() {
    if (isFlipClockInitialized) {
        return window.flipClock;
    }
    if (typeof lucide !== 'undefined') {
        lucide.createIcons();
    }

    initializeClock();

    document.addEventListener('visibilitychange', function handleVisibilityChange() {
        if (document.hidden) {
            stopClock();
        } else {
            resetClock();
            startClock();
        }
    });

    window.flipClock = new FlipClock();

    const app = window.digitalClockApp;
    const module = app && typeof app.getPageModule === 'function' ? app.getPageModule('flip') : null;
    if (module && module.settingsManager && typeof module.settingsManager.syncToggleStates === 'function') {
        module.settingsManager.syncToggleStates();
    }

    document.addEventListener('fullscreenchange', function handleFullscreenChange() {
        const clockContainer = window.flipClock?.clockContainer;
        if (!clockContainer) {
            return;
        }
        if (document.fullscreenElement === clockContainer) {
            clockContainer.classList.add('fullscreen-mode');
        } else {
            clockContainer.classList.remove('fullscreen-mode');
        }
    });

    resetClock();
    startClock();

    isFlipClockInitialized = true;
    return window.flipClock;
}

window.initializeFlipClock = initializeFlipClock;
